import React, { useCallback, useEffect, useState } from 'react'
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import { AccessGroup, ActiveInactiveBooleanOptions, BaudRateOptions, boolOptions, checkBooleanVal, DefaultSiteTechGroup, EngineSequencerStateOptions, ExerciseStateOptions, FuelTypeOptions, GaugeType, GenControllerStateOptions, LeadingLaggingNgcOptions, OnOffBooleanOptions, OpenClosedBooleanOptions, paramLabels, PhaseRotationBooleanOptions, PowerApplicationModeOptions, RedundantStarterModeOptions, SensorSelectOptions, UnitOptions, VoltagePhaseConnectionOptions, YesNoBooleanOptions } from '../../../constants';
import ClearIcon from '@mui/icons-material/Clear';
import MappingParamTable from './MappingParamTable';
import SearchIcon from '@mui/icons-material/Search';
import Loader from '../../../component/Loader/Loader';
import Breadcrumb from '../../../component/Breadcrumb';
import MappingTabing from '../../../component/MappingTabing';
import { Box, Button, Grid, TextField, Typography, Divider } from '@mui/material';
import { getDataForExistingAddresses, getParamMasterMappingData } from '../../../api/mappingApi';
import { checklocalStorageItems, saveContentFile } from '../../../utlis';
import FormNumberField from '../../../component/NumberInput';
import DropDownParam from '../../../component/DropDownParam/DropDownParam';
import TextFormField from '../../Parameters/TextFormField';
import NumberAndFloatFormField from '../../Parameters/NumberAndFloatFormField';

const MappingParameters = () => {
    const [itemForLocal, setItemForLocal]            = useState(false);
    const [showLoader, setShowLoader]                = useState(false);
    const [searchValue,setSearchValue]               = useState('');
    const [parameterData,setParameterData]           = useState([]);
    const [addressMappingData,setAddressMappingData] = useState([]);
    const [paramEditableKeys,setParamEditableKeys]   = useState({});
    const [showForm, setShowForm]                    = useState(false);
    const [showLanagueField, setShowLanagueField]    = useState(true);
    const [editRowDataType, setEditRowDataType]      = useState('');
    const [lengthCount, setLengthCount]              = useState(0);
    const [previousHash,setPreviousHash]             = useState(() => {
        const storedParam =  localStorage.getItem('Parameters');
        return storedParam ? storedParam : '';
    })
    const [editRowData, setEditRowData]              = useState({
        Addr:  '',
        ETxt:  '',
        FTxt:  '',
        STxt:  '',
        GTxt:  '',
        ITxt:  '',
        DTxt:  '',
        NTxt:  '',
        PTxt:  '',
        PeTxt: '',
        TTxt:  '',
        CTxt:  '',
        RTxt:  '',
        Min:   '',
        Max:   '',
        Val:   '',
        Unit:  '',
        RAccs: '',
        WAccs: '',
        GType: '',
        GName: '',
        CST: '',
    });

    useEffect(() => {
        const dataInLocalStorage = checklocalStorageItems();
        setItemForLocal(dataInLocalStorage);
        fetchParamterData()
        window.addEventListener('storage',fetchParamterData);
        return () => {
            window.removeEventListener('storage',fetchParamterData);
        }
    },[lengthCount,previousHash])

    const fetchParamterData = async () => {
        let parmData = JSON.parse(localStorage.getItem('Parameters'));
        const newHash = (parmData != null && parmData.length > 0) ? JSON.stringify(parmData) : '';
        if(parmData != null && parmData.length > 0){
            setLengthCount(parmData.length);
            if(parmData.length !== lengthCount || previousHash !== newHash){
                const formData = new FormData();
                const jsonData = JSON.stringify(parmData);
                formData.append('file',new Blob([jsonData],{type:'application/json'}),'data.txt');
                setShowLoader(true);
                let fetchDataForExisiting = await getDataForExistingAddresses(formData);
                setShowLoader(false);
                setPreviousHash(newHash);
                if(fetchDataForExisiting){
                    setParameterData(fetchDataForExisiting);
                }
            }
        }
    }


    const handleDropDownChange = (e) => {
        // let {name,value} = e.target;
        // if(name === 'Unit'){
        //   value = value.replaceAll(/\s/g,'');
        // } else {
        //   value = parseInt(value);
        // }
        const {name,value} = e.target;
        let finalVal;
        if(name === 'RAccs' || name === 'WAccs' || name === 'GType' || name === 'Unit' || name === 'GName'){
          finalVal = name === 'Unit' ? value.replaceAll(/\s/g,'') :  value;
        } else {
          finalVal = parseInt(value);
        }

        setEditRowData((prevState) => ({...prevState, [name]: finalVal }));
        // let selectedOption;
        // if(name === 'RAccs' || name === 'WAccs'){
        //     selectedOption = AccessGroup.find(option => option.value === value);
        // } else if(name === 'GType') {
        //     selectedOption = GaugeType.find(option => option.value === value);
        // } else if(name === 'Unit') {
        //     selectedOption = UnitOptions.find(option => option.value === value);
        // } else if(name === 'GName') {
        //     selectedOption = DefaultSiteTechGroup.find(option => option.value === value);
        // }
        //handleOnChange(name,selectedOption?.data_value);
        //handleOnChange(name,value);
    }  


    const changeHandler = useCallback((name,value) => {
        setEditRowData((prevState) => ({...prevState, [name]: value }));
    }, []);
    
    const changeHandlerFloat = useCallback((name,value) => {
        const result = decimalValidation(name,value);
        if(result){
          if(editRowDataType?.toLowerCase() === 'float' || editRowDataType?.toLowerCase() === 'double'){
            swal("Oops!", "Please use Float value for Min, Max and Default Val!", "error");
          } else {
            swal("Oops!", "Please use Float value for Min and Max!", "error");
          }
        }
        if(value % 1 === 0){
          value = Number(value) === 0 ? 0.000001 : parseFloat(value) + 0.000001;
        }
        let finalValue = parseFloat(value);
        setEditRowData((prevState) => ({...prevState, [name]: finalValue }));
    }, []);
    
    const changeHandlerInteger = useCallback((name,value) => {
        setEditRowData((prevState) => ({...prevState, [name]: parseInt(value) }));
    }, []);
    

    const decimalValidation = (name,value) => {
        let validationArray = [];
        if(editRowDataType?.toLowerCase() === 'float' || editRowDataType?.toLowerCase() === 'double'){
          validationArray = ['Min','Max','Val'];
        }
        //  else {
        //   validationArray = ['Min','Max'];
        // }
        if(validationArray.includes(name) && value !== '' && value?.toString()?.indexOf('.') === -1) {
          return true;
        } 
        return false;
      }

    const handleCloseForm = () => {
        setShowForm(false);
    }
    
    const handleSubmitRow = () => {
        let existingParam = JSON.parse(localStorage.getItem('Parameters'));
        if(existingParam == null) existingParam = [];
        let isExist = false;
        
        let valdationStatus = false;
        Object.keys(editRowData).forEach(function(key) {
            const result = decimalValidation(key,editRowData[key]);
            if(result){
                valdationStatus = true;
            }        
        });

        if(valdationStatus){
            if(editRowDataType?.toLowerCase() === 'float' || editRowDataType?.toLowerCase() === 'double'){
                swal("Oops!", "Please use Float value for Min, Max and Default Val!", "error");
                return false;
            } 
            // else {
            //     swal("Oops!", "Please use Float value for Min and Max!", "error");
            //     return false;
            // }
        }
        if(existingParam != null && existingParam.length > 0){
          existingParam =  existingParam.map((param) =>  {
            if(param.Addr === editRowData.Addr){
              isExist = true;
              return {...param,...editRowData}
            } else {
              return param;
            }
          });
        } 
        if(!isExist){
          existingParam.push(editRowData);
        }
        localStorage.setItem('Parameters',JSON.stringify(existingParam));
        setShowForm(false);
        fetchParamterData();
    } 

    const handleRowEdit = async (row) => {
        setShowForm(true);
        const masterMappingData = await getParamMasterMappingData(row.Addr);
        setAddressMappingData(masterMappingData);
        let existingParam = JSON.parse(localStorage.getItem('Parameters'));
        existingParam = existingParam.find(param => param.Addr === row?.Addr);
        setParamEditableKeys(existingParam)
        setEditRowDataType(masterMappingData.DataType)
        setEditRowData({
          Addr: row?.Addr,
          ETxt: row?.ETxt,
          FTxt: row?.FTxt,
          STxt: row?.STxt,
          GTxt: row?.GTxt,
          ITxt: row?.ITxt,
          DTxt: row?.DTxt,
          NTxt: row?.NTxt,
          PTxt: row?.PTxt,
          PeTxt: row?.PeTxt,
          TTxt: row?.TTxt,
          CTxt: row?.CTxt,
          RTxt: row?.RTxt,
          Min: row?.Min,
          Max: row?.Max,
          Val: row?.Val,
          Unit: row?.Unit,
          RAccs: row?.RAccs,
          WAccs: row?.WAccs,
          GType: row?.GType,
          GName: row?.GName,
          CST: row?.CST,
        });
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    const handleRowDelete = (rowIndex) => {
        const newArray = [...parameterData];
        newArray.splice(rowIndex, 1);
        setParameterData(newArray);
        if(newArray.length === 0){
            localStorage.removeItem("Parameters");
        } else {
            localStorage.setItem('Parameters',JSON.stringify(newArray));
        }
        const storedParam =  localStorage.getItem('Parameters');
        setPreviousHash(storedParam ? storedParam : '');
    }

    const handleAddButton = (e) => {
        window.open('/parameters','_blank','noopener,noreferrer,width=auto,height=auto')
    }    

    const handleChangeTextValue = (e) => {
        setSearchValue(e.target.value)
    }

    const handleSearch = async () => {
        setShowLoader(true);
        let parmData = JSON.parse(localStorage.getItem('Parameters'));
        if(parmData != null && parmData.length > 0){
            const formData = new FormData();
            const jsonData = JSON.stringify(parmData);
            formData.append('file',new Blob([jsonData],{type:'application/json'}),'data.txt')
            let fetchDataForExisiting = await getDataForExistingAddresses(formData);
            setShowLoader(false);
            if(fetchDataForExisiting) {
                if(searchValue !== ''){
                    let filterResults = fetchDataForExisiting.filter((data) => data.EnglishText === searchValue);
                    setParameterData(filterResults);
                } else {
                    setParameterData(fetchDataForExisiting);
                }
            }
        }
        setShowLoader(false);
    }

    const clearSearchValue = () => {
        setSearchValue('')
        setLengthCount(0);
    }

    const handleConfigFileContent = async() => {
        setShowLoader(true);
        const result = await saveContentFile();
        setShowLoader(false);
        if(result){
            swal({
              title: "Success",
              text: result.message,
              icon: "success",
            })
        }
    }

    const handleDropDownChangeBoolean = (e) => {
        const {name,value} = e.target;
        const boolValue =value === true || value === "true" || value === 1 || value === "1";
        setEditRowData((prevState) => ({...prevState, [name]: boolValue }));
    }  

    return (
        <>
            {showLoader && 
                <Loader />
            }
            <Breadcrumb  title="Configuration Paramters">
                <Typography component={Link} to="/" variant="subtitle2" color="primary"  className="link-breadcrumb">
                Dashboard
                </Typography>
                <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
                Paramters
                </Typography>
            </Breadcrumb>
            <MappingTabing 
                value="param" 
                handleConfigFileContent={handleConfigFileContent}
            />
            
            <Box  component="section">
                <Grid className="contentBox">
                    <Grid className="modbusButtons" container direction="row" display={'flex'} justifyContent={'space-between'}>
                        <Grid item >
                            <Box sx={{ ml:4,display: 'flex', alignItems: 'flex-end'}}>
                                <TextField id="input-with-sx" value={searchValue} label="Search By English Text" variant="standard" onChange={handleChangeTextValue} />
                                <SearchIcon onClick={handleSearch} sx={{cursor:'pointer', color: '#74737B', mr: 0.5,my: 0.5  }} />
                                <ClearIcon onClick={clearSearchValue} sx={{cursor:'pointer', color: '#FF413A', my: 0.5 }} />
                            </Box>
                        </Grid>
                        {itemForLocal &&
                            <Grid item sx={{pt: { xs: 2,sm:1 },pl: { xs: 4 }}}>
                                <Button
                                    onClick={handleAddButton}
                                    variant="contained"
                                    size="small"
                                    color="primary"
                                    sx={{mr:3}}
                                >Add 
                                </Button>
                            </Grid>
                        }
                       </Grid>
                    {parameterData.length === 0  &&
                        <p>No Data Available.</p>
                    }
                    {showForm &&
                        <>
                        <Divider sx={{mb:2}} />
                        <Grid className='editParamFields' container sx={{ mb: 2, display: 'flex' }}>
                            {Object.keys(editRowData).map((field) => {
                                
                                const value = paramEditableKeys[field] ? ( editRowData[field] !== null && editRowData[field] !== undefined) ? editRowData[field] : '' : editRowData[field] === '' ? '' : addressMappingData[field];

                                if(field === 'RAccs' || field === 'WAccs' || field === 'GType' || field === 'Unit' || field === 'GName'){
        
                                    let dropwnDownSelectVal;
                                    if(field === 'GType'){
                                        dropwnDownSelectVal = editRowData[field] !== "" && editRowData[field] !== null && editRowData[field] !== undefined ?  GaugeType.find((opt) => opt?.value === editRowData[field])?.value : editRowData[field] === '' ? '' : GaugeType.find((opt) => opt?.value === addressMappingData[field])?.value;
                                    } else if(field === 'Unit') {
                                        dropwnDownSelectVal = editRowData[field] !== "" && editRowData[field] !== null && editRowData[field] !== undefined ?  UnitOptions.find((opt) => opt?.value === editRowData[field])?.value : editRowData[field] === '' ? ' ' : UnitOptions.find((opt) => opt?.value === addressMappingData[field])?.value;
                                    } else if (field === 'GName') {
                                        dropwnDownSelectVal = editRowData[field] !== "" && editRowData[field] !== null && editRowData[field] !== undefined ?  DefaultSiteTechGroup.find((opt) => opt?.value === editRowData[field])?.value : editRowData[field] === '' ? '' : DefaultSiteTechGroup.find((opt) => opt?.value === addressMappingData[field])?.value;
                                    } else if(field === 'RAccs' || field === 'WAccs'){
                                        dropwnDownSelectVal = editRowData[field] !== "" && editRowData[field] !== null && editRowData[field] !== undefined ?  AccessGroup.find((opt) => opt?.value === editRowData[field])?.value : editRowData[field] === '' ? '' : AccessGroup.find((opt) => opt?.value === addressMappingData[field])?.value;
                                    }
                                    
                                    return (
                                        <DropDownParam 
                                            width={false}
                                            label={paramLabels[field]}
                                            name={field}
                                            key={field}
                                            value={ dropwnDownSelectVal || ""}
                                            options={field === 'GType' ? GaugeType : field === 'Unit' ? UnitOptions : field === 'GName' ? DefaultSiteTechGroup : AccessGroup  }
                                            handleDropDownChange={handleDropDownChange}
                                            className={paramEditableKeys[field] !== undefined && paramEditableKeys[field] !== "" && paramEditableKeys[field] !== null && field !== 'Addr' ? 'updatedMappingField' : ''}
                                        />
                                    )
                                } else if(field === 'Min' || field === 'Max'){
                                    if(editRowDataType?.toLowerCase() === 'string'){
                                      return (
                                        <TextFormField 
                                            label = {paramLabels[field]}
                                            key={field}
                                            name={field}
                                            value={value}
                                            onHandleChange={changeHandler} 
                                            className={paramEditableKeys[field] && field !== 'Addr' ? 'updatedMappingField' : ''}
                                        />
                                      )
                                    } else if(editRowDataType?.toLowerCase() === 'int8' || editRowDataType?.toLowerCase() === 'int16' || editRowDataType?.toLowerCase() === 'int32' || editRowDataType?.toLowerCase() === 'int64' || editRowDataType?.toLowerCase() === 'uint8'  || editRowDataType?.toLowerCase() === 'uint16' || editRowDataType?.toLowerCase() === 'uint32' || editRowDataType?.toLowerCase() === 'uint64') {
                                        return (
                                            <NumberAndFloatFormField 
                                                label = {paramLabels[field]}
                                                key={field}
                                                width={false}
                                                name={field} 
                                                value={value} 
                                                onHandleChange={changeHandlerInteger}
                                                type="int"
                                            />
                                        ) 
                                    } else if(editRowDataType?.toLowerCase() === 'float' || editRowDataType?.toLowerCase() === 'double') {
                                        return(
                                            <NumberAndFloatFormField 
                                                label = {paramLabels[field]}
                                                key={field}
                                                width={false}
                                                name={field} 
                                                value={value} 
                                                onHandleChange={changeHandlerFloat}
                                            />
                                        )
                                    } else if(editRowDataType?.toLowerCase() === 'activeinactiveboolean' || editRowDataType?.toLowerCase() === 'bool' || editRowDataType?.toLowerCase() === 'boolean' || editRowDataType?.toLowerCase() === 'openclosedboolean' || editRowDataType?.toLowerCase() === 'yesnoboolean' || editRowDataType?.toLowerCase() === 'leadinglaggingboolean' || editRowDataType?.toLowerCase() === 'phaserotationboolean' || editRowDataType?.toLowerCase() === 'onoffboolean') {
                                        return(
                                            <NumberAndFloatFormField 
                                                label={paramLabels[field]}
                                                width={false}
                                                name={field} 
                                                value={value} 
                                                onHandleChange={changeHandlerInteger}
                                                type="int"
                                            />
                                        )
                                    } else {
                                        return(
                                            <NumberAndFloatFormField 
                                                label={paramLabels[field]}
                                                width={false}
                                                name={field} 
                                                value={value} 
                                                onHandleChange={changeHandlerInteger}
                                                type="int"
                                                className={paramEditableKeys[field] && field !== 'Addr' ? 'updatedMappingField' : ''}
                                            />
                                        )
                                    }
                                    
                                } else if(field === 'Val') {
                                    if(editRowDataType?.toLowerCase() === 'string'){
                                      return (
                                        <TextFormField 
                                            label = {paramLabels[field]}
                                            key={field}
                                            name={field}
                                            value={value}
                                            onHandleChange={changeHandler} 
                                            className={paramEditableKeys[field] && field !== 'Addr' ? 'updatedMappingField' : ''}
                                        />
                                      )
                                    } else if(editRowDataType?.toLowerCase() === 'boolean' || editRowDataType?.toLowerCase() === 'bool') { 
                                        // let selectVal = editRowData[field] !== "" && editRowData[field] !== null && editRowData[field] !== undefined ?  boolOptions.find((opt) => opt?.value === editRowData[field]?.toString())?.value : editRowData[field] === '' ? '' : boolOptions.find((opt) => opt?.value === addressMappingData[field]?.toString())?.value;
                                        const rawValue =
                                        editRowData[field] !== null &&
                                        editRowData[field] !== undefined &&
                                        editRowData[field] !== ""
                                            ? editRowData[field]
                                            : addressMappingData[field];
                                        const selectVal = checkBooleanVal(rawValue);
                                        const selectedOption =
                                        boolOptions.find(
                                            opt => opt.value === selectVal
                                        ) || null;
                                        return (
                                          <DropDownParam
                                            width={false}
                                            label={paramLabels[field]}
                                            name={field}
                                            key={field}
                                            value={selectedOption?.value}
                                            options={boolOptions}
                                            handleDropDownChange={handleDropDownChangeBoolean}
                                            className={paramEditableKeys[field] !== undefined && paramEditableKeys[field] !== "" && paramEditableKeys[field] !== null && field !== 'Addr' ? 'updatedMappingField' : ''}
                                          />
                                        )
                                    } else if(editRowDataType?.toLowerCase() === 'fueltype') { 
                                        let selectVal = editRowData[field] !== "" && editRowData[field] !== null && editRowData[field] !== undefined ?  FuelTypeOptions.find((opt) => opt?.value === editRowData[field]?.toString())?.value : editRowData[field] === '' ? '' : FuelTypeOptions.find((opt) => opt?.value === addressMappingData[field]?.toString())?.value;
                                        return (
                                          <DropDownParam
                                            width={false}
                                            label={paramLabels[field]}
                                            name={field}
                                            key={field}
                                            value={selectVal || ""}
                                            options={FuelTypeOptions}
                                            handleDropDownChange={handleDropDownChange}
                                            className={paramEditableKeys[field] !== undefined && paramEditableKeys[field] !== "" && paramEditableKeys[field] !== null && field !== 'Addr' ? 'updatedMappingField' : ''}
                                        />
                                        )
                                    } else if(editRowDataType?.toLowerCase() === 'yesnoboolean') {
                                        const rawValue =
                                        editRowData[field] !== null &&
                                        editRowData[field] !== undefined &&
                                        editRowData[field] !== ""
                                            ? editRowData[field]
                                            : addressMappingData[field];
                                        const selectVal = checkBooleanVal(rawValue);
                                        const selectedOption =
                                        YesNoBooleanOptions.find(
                                            opt => opt.value === selectVal
                                        ) || null;

                                        return (
                                          <DropDownParam
                                            width={false}
                                            label={paramLabels[field]}
                                            name={field}
                                            key={field}
                                            value={selectedOption?.value}
                                            options={YesNoBooleanOptions}
                                            handleDropDownChange={handleDropDownChangeBoolean}
                                            className={paramEditableKeys[field] !== undefined && paramEditableKeys[field] !== "" && paramEditableKeys[field] !== null && field !== 'Addr' ? 'updatedMappingField' : ''}
                                          />
                                        )
                                    }  else if(editRowDataType?.toLowerCase() === 'onoffboolean') {
                                        const rawValue =
                                        editRowData[field] !== null &&
                                        editRowData[field] !== undefined &&
                                        editRowData[field] !== ""
                                            ? editRowData[field]
                                            : addressMappingData[field];
                                        const selectVal = checkBooleanVal(rawValue);
                                        const selectedOption =
                                        OnOffBooleanOptions.find(
                                            opt => opt.value === selectVal
                                        ) || null;

                                        return (
                                          <DropDownParam
                                            width={false}
                                            label={paramLabels[field]}
                                            name={field}
                                            key={field}
                                            value={selectedOption?.value}
                                            options={OnOffBooleanOptions}
                                            handleDropDownChange={handleDropDownChangeBoolean}
                                            className={paramEditableKeys[field] !== undefined && paramEditableKeys[field] !== "" && paramEditableKeys[field] !== null && field !== 'Addr' ? 'updatedMappingField' : ''}
                                          />
                                        )
                                    } else if(editRowDataType?.toLowerCase() === 'openclosedboolean') { 
                                        // let selectVal = editRowData[field] !== "" && editRowData[field] !== null && editRowData[field] !== undefined ?  OpenClosedBooleanOptions.find((opt) => opt?.value === editRowData[field]?.toString())?.value : editRowData[field] === '' ? '' : OpenClosedBooleanOptions.find((opt) => opt?.value === addressMappingData[field]?.toString())?.value;
                                        const rawValue =
                                        editRowData[field] !== null &&
                                        editRowData[field] !== undefined &&
                                        editRowData[field] !== ""
                                            ? editRowData[field]
                                            : addressMappingData[field];
                                        const selectVal = checkBooleanVal(rawValue);
                                        const selectedOption =
                                        OpenClosedBooleanOptions.find(
                                            opt => opt.value === selectVal
                                        ) || null;
                                        return (
                                          <DropDownParam
                                            width={false}
                                            label={paramLabels[field]}
                                            name={field}
                                            key={field}
                                            value={selectedOption?.value}
                                            options={OpenClosedBooleanOptions}
                                            handleDropDownChange={handleDropDownChangeBoolean}
                                            className={paramEditableKeys[field] !== undefined && paramEditableKeys[field] !== "" && paramEditableKeys[field] !== null && field !== 'Addr' ? 'updatedMappingField' : ''}
                                          />
                                        )
                                    } else if(editRowDataType?.toLowerCase() === 'activeinactiveboolean') { 
                                        // let selectVal = editRowData[field] !== "" && editRowData[field] !== null && editRowData[field] !== undefined ?  ActiveInactiveBooleanOptions.find((opt) => opt?.value === editRowData[field]?.toString())?.value : editRowData[field] === '' ? '' : ActiveInactiveBooleanOptions.find((opt) => opt?.value === addressMappingData[field]?.toString())?.value;
                                        const rawValue =
                                        editRowData[field] !== null &&
                                        editRowData[field] !== undefined &&
                                        editRowData[field] !== ""
                                            ? editRowData[field]
                                            : addressMappingData[field];
                                        const selectVal = checkBooleanVal(rawValue);
                                        const selectedOption =
                                        ActiveInactiveBooleanOptions.find(
                                            opt => opt.value === selectVal
                                        ) || null;
                                        return (
                                          <DropDownParam
                                            width={false}
                                            label={paramLabels[field]}
                                            name={field}
                                            key={field}
                                            value={selectedOption?.value}
                                            options={ActiveInactiveBooleanOptions}
                                            handleDropDownChange={handleDropDownChangeBoolean}
                                            className={paramEditableKeys[field] !== undefined && paramEditableKeys[field] !== "" && paramEditableKeys[field] !== null && field !== 'Addr' ? 'updatedMappingField' : ''}
                                          />
                                        )
                                    } else if(editRowDataType?.toLowerCase() === 'baudrate') { 
                                        let selectVal = editRowData[field] !== "" && editRowData[field] !== null && editRowData[field] !== undefined ?  BaudRateOptions.find((opt) => opt?.value === editRowData[field]?.toString())?.value : editRowData[field] === '' ? '' : BaudRateOptions.find((opt) => opt?.value === addressMappingData[field]?.toString())?.value;
                                        return (
                                          <DropDownParam
                                            width={false}
                                            label={paramLabels[field]}
                                            name={field}
                                            key={field}
                                            value={selectVal || ""}
                                            options={BaudRateOptions}
                                            handleDropDownChange={handleDropDownChange}
                                            className={paramEditableKeys[field] !== undefined && paramEditableKeys[field] !== "" && paramEditableKeys[field] !== null && field !== 'Addr' ? 'updatedMappingField' : ''}
                                          />
                                        )
                                    } else if(editRowDataType?.toLowerCase() === 'exercisestate') { 
                                        let selectVal = editRowData[field] !== "" && editRowData[field] !== null && editRowData[field] !== undefined ?  ExerciseStateOptions.find((opt) => opt?.value === editRowData[field]?.toString())?.value : editRowData[field] === '' ? '' : ExerciseStateOptions.find((opt) => opt?.value === addressMappingData[field]?.toString())?.value;
                                        return (
                                          <DropDownParam
                                            width={false}
                                            label={paramLabels[field]}
                                            name={field}
                                            key={field}
                                            value={selectVal || ""}
                                            options={ExerciseStateOptions}
                                            handleDropDownChange={handleDropDownChange}
                                            className={paramEditableKeys[field] !== undefined && paramEditableKeys[field] !== "" && paramEditableKeys[field] !== null && field !== 'Addr' ? 'updatedMappingField' : ''}
                                          />
                                        )
                                    } else if(editRowDataType?.toLowerCase() === 'sensorselect') {
                                        let selectVal = editRowData[field] !== "" && editRowData[field] !== null && editRowData[field] !== undefined ?  SensorSelectOptions.find((opt) => opt?.value === editRowData[field]?.toString())?.value : editRowData[field] === '' ? '' : SensorSelectOptions.find((opt) => opt?.value === addressMappingData[field]?.toString())?.value; 
                                        return (
                                          <DropDownParam
                                            width={false}
                                            label={paramLabels[field]}
                                            name={field}
                                            key={field}
                                            value={selectVal || ""}
                                            options={SensorSelectOptions}
                                            handleDropDownChange={handleDropDownChange}
                                            className={paramEditableKeys[field] !== undefined && paramEditableKeys[field] !== "" && paramEditableKeys[field] !== null && field !== 'Addr' ? 'updatedMappingField' : ''}
                                          />
                                        )
                                    } else if(editRowDataType?.toLowerCase() === 'leadinglaggingboolean') { 
                                        // let selectVal = editRowData[field] !== "" && editRowData[field] !== null && editRowData[field] !== undefined ?  LeadingLaggingNgcOptions.find((opt) => opt?.value === editRowData[field]?.toString())?.value : editRowData[field] === '' ? '' : LeadingLaggingNgcOptions.find((opt) => opt?.value === addressMappingData[field]?.toString())?.value; 
                                        const rawValue =
                                        editRowData[field] !== null &&
                                        editRowData[field] !== undefined &&
                                        editRowData[field] !== ""
                                            ? editRowData[field]
                                            : addressMappingData[field];
                                        const selectVal = checkBooleanVal(rawValue);
                                        const selectedOption =
                                        LeadingLaggingNgcOptions.find(
                                            opt => opt.value === selectVal
                                        ) || null;
                                        return (
                                          <DropDownParam
                                            width={false}
                                            label={paramLabels[field]}
                                            name={field}
                                            key={field}
                                            value={selectedOption?.value}
                                            options={LeadingLaggingNgcOptions}
                                            handleDropDownChange={handleDropDownChangeBoolean}
                                            className={paramEditableKeys[field] !== undefined && paramEditableKeys[field] !== "" && paramEditableKeys[field] !== null && field !== 'Addr' ? 'updatedMappingField' : ''}
                                          />
                                        )
                                    } else if(editRowDataType?.toLowerCase() === 'phaserotationboolean') { 
                                        // let selectVal = editRowData[field] !== "" && editRowData[field] !== null && editRowData[field] !== undefined ?  LeadingLaggingNgcOptions.find((opt) => opt?.value === editRowData[field]?.toString())?.value : editRowData[field] === '' ? '' : LeadingLaggingNgcOptions.find((opt) => opt?.value === addressMappingData[field]?.toString())?.value; 
                                        const rawValue =
                                        editRowData[field] !== null &&
                                        editRowData[field] !== undefined &&
                                        editRowData[field] !== ""
                                            ? editRowData[field]
                                            : addressMappingData[field];
                                        const selectVal = checkBooleanVal(rawValue);
                                        const selectedOption =
                                        PhaseRotationBooleanOptions.find(
                                            opt => opt.value === selectVal
                                        ) || null;
                                        return (
                                          <DropDownParam
                                            width={false}
                                            label={paramLabels[field]}
                                            name={field}
                                            key={field}
                                            value={selectedOption?.value}
                                            options={PhaseRotationBooleanOptions}
                                            handleDropDownChange={handleDropDownChangeBoolean}
                                            className={paramEditableKeys[field] !== undefined && paramEditableKeys[field] !== "" && paramEditableKeys[field] !== null && field !== 'Addr' ? 'updatedMappingField' : ''}
                                          />
                                        )
                                    } else if(editRowDataType?.toLowerCase() === 'gencontrollerstate') {
                                        let selectVal = editRowData[field] !== "" && editRowData[field] !== null && editRowData[field] !== undefined ?  GenControllerStateOptions.find((opt) => opt?.value === editRowData[field]?.toString())?.value : editRowData[field] === '' ? '' : GenControllerStateOptions.find((opt) => opt?.value === addressMappingData[field]?.toString())?.value; 
                                        return (
                                          <DropDownParam
                                            width={false}
                                            label={paramLabels[field]}
                                            name={field}
                                            key={field}
                                            value={selectVal || ""}
                                            options={GenControllerStateOptions}
                                            handleDropDownChange={handleDropDownChange}
                                            className={paramEditableKeys[field] !== undefined && paramEditableKeys[field] !== "" && paramEditableKeys[field] !== null && field !== 'Addr' ? 'updatedMappingField' : ''}
                                          />
                                        )
                                    } else if(editRowDataType?.toLowerCase() === 'voltagephaseconnection') { 
                                        let selectVal = editRowData[field] !== "" && editRowData[field] !== null && editRowData[field] !== undefined ?  VoltagePhaseConnectionOptions.find((opt) => opt?.value === editRowData[field]?.toString())?.value : editRowData[field] === '' ? '' : VoltagePhaseConnectionOptions.find((opt) => opt?.value === addressMappingData[field]?.toString())?.value; 
                                        return (
                                          <DropDownParam
                                            width={false}
                                            label={paramLabels[field]}
                                            name={field}
                                            key={field}
                                            value={selectVal || ""}
                                            options={VoltagePhaseConnectionOptions}
                                            handleDropDownChange={handleDropDownChange}
                                            className={paramEditableKeys[field] !== undefined && paramEditableKeys[field] !== "" && paramEditableKeys[field] !== null && field !== 'Addr' ? 'updatedMappingField' : ''}
                                          />
                                        )
                                    } else if(editRowDataType?.toLowerCase() === 'powerapplicationmode') { 
                                        let selectVal = editRowData[field] !== "" && editRowData[field] !== null && editRowData[field] !== undefined ?  PowerApplicationModeOptions.find((opt) => opt?.value === editRowData[field]?.toString())?.value : editRowData[field] === '' ? '' : PowerApplicationModeOptions.find((opt) => opt?.value === addressMappingData[field]?.toString())?.value; 
                                        return (
                                          <DropDownParam
                                            width={false}
                                            label={paramLabels[field]}
                                            name={field}
                                            key={field}
                                            value={selectVal || ""}
                                            options={PowerApplicationModeOptions}
                                            handleDropDownChange={handleDropDownChange}
                                            className={paramEditableKeys[field] !== undefined && paramEditableKeys[field] !== "" && paramEditableKeys[field] !== null && field !== 'Addr' ? 'updatedMappingField' : ''}
                                          />
                                        )
                                    } else if(editRowDataType?.toLowerCase() === 'redundantstartermode') {
                                        let selectVal = editRowData[field] !== "" && editRowData[field] !== null && editRowData[field] !== undefined ?  RedundantStarterModeOptions.find((opt) => opt?.value === editRowData[field]?.toString())?.value : editRowData[field] === '' ? '' : RedundantStarterModeOptions.find((opt) => opt?.value === addressMappingData[field]?.toString())?.value; 
                                        return (
                                          <DropDownParam
                                            width={false}
                                            label={paramLabels[field]}
                                            name={field}
                                            key={field}
                                            value={selectVal || ""}
                                            options={RedundantStarterModeOptions}
                                            handleDropDownChange={handleDropDownChange}
                                            className={paramEditableKeys[field] !== undefined && paramEditableKeys[field] !== "" && paramEditableKeys[field] !== null && field !== 'Addr' ? 'updatedMappingField' : ''}
                                          />
                                        )
                                    } else if(editRowDataType?.toLowerCase() === 'enginesequencerstate') { 
                                        let selectVal = editRowData[field] !== "" && editRowData[field] !== null && editRowData[field] !== undefined ?  EngineSequencerStateOptions.find((opt) => opt?.value === editRowData[field]?.toString())?.value : editRowData[field] === '' ? '' : EngineSequencerStateOptions.find((opt) => opt?.value === addressMappingData[field]?.toString())?.value;
                                        return (
                                          <DropDownParam
                                            width={false}
                                            label={paramLabels[field]}
                                            name={field}
                                            key={field}
                                            value={selectVal || ""}
                                            options={EngineSequencerStateOptions}
                                            handleDropDownChange={handleDropDownChange}
                                            className={paramEditableKeys[field] !== undefined && paramEditableKeys[field] !== "" && paramEditableKeys[field] !== null && field !== 'Addr' ? 'updatedMappingField' : ''}
                                          />
                                        )
                                    } else if(editRowDataType?.toLowerCase() === 'int8' || editRowDataType?.toLowerCase() === 'int16' || editRowDataType?.toLowerCase() === 'int32' || editRowDataType?.toLowerCase() === 'int64' || editRowDataType?.toLowerCase() === 'uint8' || editRowDataType?.toLowerCase() === 'uint16' || editRowDataType?.toLowerCase() === 'uint32' || editRowDataType?.toLowerCase() === 'uint64') {
                                        return (
                                          <NumberAndFloatFormField 
                                            label={paramLabels[field]}
                                            width={false}
                                            name={field} 
                                            value={value} 
                                            onHandleChange={changeHandlerInteger}
                                            type="int"
                                            className={paramEditableKeys[field] && field !== 'Addr' ? 'updatedMappingField' : ''}
                                          />
                                        ) 
                                    } else if(editRowDataType?.toLowerCase() === 'float' || editRowDataType?.toLowerCase() === 'double') {
                                        return (
                                          <NumberAndFloatFormField
                                            label={paramLabels[field]}
                                            width={false}
                                            name={field} 
                                            value={value} 
                                            onHandleChange={changeHandlerFloat}
                                            className={paramEditableKeys[field] && field !== 'Addr' ? 'updatedMappingField' : ''}
                                          />
                                        ) 
                                    }  else {
                                         return (
                                          <NumberAndFloatFormField 
                                            label={paramLabels[field]}
                                            width={false}
                                            name={field} 
                                            value={value} 
                                            onHandleChange={changeHandlerInteger}
                                            type="int"
                                            className={paramEditableKeys[field] && field !== 'Addr' ? 'updatedMappingField' : ''}
                                          />
                                        ) 
                                    }
                                } else {
                                    if((field === 'Addr' || field === 'ETxt' || field === 'CST') && showLanagueField === true) {
                                        return (
                                            <TextFormField 
                                                label={paramLabels[field]} 
                                                name={field} 
                                                value={value} 
                                                onHandleChange={changeHandler} 
                                                width={false}
                                                className={paramEditableKeys[field] && field !== 'Addr' ? 'updatedMappingField' : ''}
                                            />
                                        )
                                    }

                                    if(showLanagueField === false){
                                        return (
                                            <TextFormField 
                                                label={paramLabels[field]} 
                                                name={field} 
                                                value={value} 
                                                onHandleChange={changeHandler} 
                                                width={false}
                                                className={paramEditableKeys[field] && field !== 'Addr' ? 'updatedMappingField' : ''}
                                            />  
                                        )
                                    }
                                }
                                return null;
                            })}
                        </Grid>
                        <>
                        <Button 
                            sx={{ mb: 2 }} 
                            color="primary" 
                            onClick={handleSubmitRow} 
                            variant="contained"
                            size="small" 
                        >Submit</Button>
                        <Button 
                            sx={{ mb: 2, ml:2 , mr:2}} 
                            color="error" 
                            onClick={handleCloseForm} 
                            variant="contained"
                            size="small" 
                        >Cancel</Button>
                        </>
                        <Button 
                            sx={{ mb: 2 }} 
                            size="small" 
                            color="secondary" 
                            onClick={() => showLanagueField ? setShowLanagueField(false) : setShowLanagueField(true) } 
                            variant="contained">
                            {showLanagueField ? 'Show Language Fields'  : 'Hide Language Fields' }
                        </Button>
                        </>
                    }
                    
                    <MappingParamTable
                        data={parameterData}
                        handleRowEdit={handleRowEdit}
                        handleRowDelete={handleRowDelete}
                        setShowLoader={setShowLoader}
                    />
                </Grid>
            </Box>
        </>    
    )
}

export default MappingParameters